/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import { Remove } from "@material-ui/icons";

// PAGES
import DashboardPage from "views/Dashboard/DashboardAdminUser.js";
import MyAccount from "views/AdminUser/MyAccount.js";

const dashboardRoutes = [
  {
    id: 0,
    subId: "",
    path: "/dashboard",
    name: "Inicio",
    rtlName: "لوحة القيادة",
    icon: Remove,
    component: DashboardPage,
    layout: "/adminuser",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/myaccount",
    name: "Mi perfil",
    rtlName: "لوحة القيادة",
    icon: Remove,
    component: MyAccount,
    layout: "/adminuser",
    submenu: [],
  },
];

export default dashboardRoutes;
